import { ChangeDetectionStrategy, Component } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AuthenticationService } from 'src/app/modules/authentication/services/authentication.service';
import { environment } from '../../../../environments/environment';
import { CoreService } from '../../services/core.service';
import { SubmenuItem } from '../menu-item/menu-item.component';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuComponent {
  serverConfig = toSignal(this.coreService.serverInfo$);
  interventionSubmenu: SubmenuItem[] = [
    {
      label: $localize`Overzicht`,
      link: 'intervention/overview',
      permissions: { permissions: ['Web.InterventionSearch'] },
    },
    {
      label: $localize`Simulator`,
      link: 'intervention/simulator',
      permissions: { permissions: ['Web.InterventionSimulation'] },
    },
    {
      label: $localize`XML Tester`,
      link: 'intervention/xmltester',
      permissions: { permissions: ['Web.InterventionXmlTest'] },
    },
  ];
  roundSubmenu: SubmenuItem[] = [
    { label: $localize`Aanvragen`, link: 'round/requests', permissions: { permissions: ['InTheField.RoundManage'] } },
    { label: $localize`Rondes`, link: 'round/rounds', permissions: { permissions: ['InTheField.RoundManage'] } },
  ];
  personSubmenu: SubmenuItem[] = [
    { label: $localize`Overzicht`, link: 'person/overview', permissions: { permissions: ['Web.PersonSearch'] } },
    {
      label: $localize`Eigenschappen`,
      link: 'person/property-values',
      permissions: { permissions: ['Web.PersonPropertyValues'] },
    },
  ];
  vehicleSubmenu: SubmenuItem[] = [
    {
      label: $localize`Fysieke voertuigen`,
      permissions: { permissions: ['Web.VehicleSearch', 'Web.VehicleTrackAndTrace'], inclusivity: 'some' },
      isHeader: true,
      items: [
        {
          label: $localize`Overzicht`,
          link: 'vehicle/physical/overview',
          permissions: { permissions: ['Web.VehicleSearch'] },
        },
        {
          label: $localize`Track & Trace`,
          link: 'vehicle/physical/track-and-trace',
          permissions: { permissions: ['Web.VehicleTrackAndTrace'] },
        },
      ],
    },
    {
      label: $localize`Logische voertuigen`,
      permissions: {
        permissions: [
          'Web.UnitPositionView',
          'Web.UnitTypeView',
          'Web.UnitStatusHistory',
          'Web.UnitOverview',
          'Web.UnitView',
          'Web.UnitEdit',
        ],
        inclusivity: 'some',
      },
      isHeader: true,
      items: [
        {
          label: $localize`Overzicht`,
          link: 'vehicle/logical/overview',
          permissions: { permissions: ['Web.UnitOverview'] },
        },
        { label: $localize`Types`, link: 'vehicle/logical/types', permissions: { permissions: ['Web.UnitTypeView'] } },
        {
          label: $localize`Posities`,
          link: 'vehicle/logical/positions',
          permissions: { permissions: ['Web.UnitPositionView'] },
        },
        {
          label: $localize`Historiek`,
          link: 'vehicle/logical/history',
          permissions: { permissions: ['Web.UnitStatusHistory'] },
        },
      ],
    },
  ];

  constructor(
    private readonly authService: AuthenticationService,
    private readonly coreService: CoreService
  ) {}

  onLogOut() {
    this.authService.logout();
  }

  onClickClassic(e: MouseEvent) {
    // During development we redirect manually to dev instance.
    if (!environment.production) {
      e.preventDefault();
      window.open('http://vm-ffe-dev.frontforce.be/FrontForce');
    }
  }
}
